import Weather from './components/Weather.jsx';
import React, { useEffect } from 'react';
import './index.css';
function App() {
  useEffect(() => {
    const currentHour = new Date().getHours();
    const body = document.body;

    if (currentHour >= 6 && currentHour < 18) {
      // if (currentHour >= 18 && currentHour < 6) {
      body.classList.add('day-background');
      body.classList.remove('night-background');
    } else {
      body.classList.add('night-background');
      body.classList.remove('day-background');
    }
  }, []);
  return (
   <Weather />
  );
}

export default App;
